import $ from 'jquery'
import Bugsnag from '@bugsnag/js'
import Event from 'base/event'
import Hub from 'base/hub'
import React, { Fragment } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import store from 'base/store'
import useAfterFirstRender from 'base/react/hooks/useAfterFirstRender'

const MAIN_SELECTOR = '#content'

function AdvanceAfterRender({ children }) {
  useAfterFirstRender(() => {
    Hub.pub(Event.App.TRANSITION_RENDER)
  })
  return children
}

export default function renderReduxComponent(Component, props = {}) {
  if (typeof Component === 'undefined') {
    throw new Error('renderComponentWithStoreContext got passed an undefined component')
  }

  const ErrorBoundary = Bugsnag?.getPlugin('react')?.createErrorBoundary(React) || Fragment
  const domContainer = $(props.container || MAIN_SELECTOR)
  const Wrapper = domContainer.is(MAIN_SELECTOR) ? AdvanceAfterRender : Fragment
  const element = React.createElement(Component, props)
  ReactDOM.render(
    <ErrorBoundary>
      <Provider store={store}>
        <Wrapper>{element}</Wrapper>
      </Provider>
    </ErrorBoundary>,
    domContainer.get(0),
  )
}
